import React, { useState, useEffect } from 'react'
import { DataTable, Button } from '@paypalcorp/pp-react'
import { TextInputWrapper } from '../components/pp-react-wrappers'
import Fuse from 'fuse.js'

const CodeCell = (value) => {
  return <code>{value.value}</code>
}

const allRows = [
  {
    id: 'row1',
    name: {
      value: 'Australian Dollar',
    },
    value: {
      value: 'AUD',
    },
  },
  {
    id: 'row2',
    name: {
      value: 'Brazilian real',
    },
    value: {
      value: 'BRL',
    },
  },
  {
    id: 'row3',
    name: {
      value: 'Canadian dollar',
    },
    value: {
      value: 'CAD',
    },
  },
  {
    id: 'row4',
    name: {
      value: 'Czech koruna',
    },
    value: {
      value: 'CZK',
    },
  },
  {
    id: 'row5',
    name: {
      value: 'Danish krone',
    },
    value: {
      value: 'DKK',
    },
  },
  {
    id: 'row6',
    name: {
      value: 'Euro',
    },
    value: {
      value: 'EUR',
    },
  },
  {
    id: 'row7',
    name: {
      value: 'Hong Kong dollar',
    },
    value: {
      value: 'HKD',
    },
  },
  {
    id: 'row8',
    name: {
      value: 'Hungarian forint',
    },
    value: {
      value: 'HUF',
    },
  },
  {
    id: 'row9',
    name: {
      value: 'Israeli new shekel',
    },
    value: {
      value: 'ILS',
    },
  },
  {
    id: 'row10',
    name: {
      value: 'Japanese yen',
    },
    value: {
      value: 'JPY',
    },
  },
  {
    id: 'row11',
    name: {
      value: 'Malaysian ringgit',
    },
    value: {
      value: 'MYR',
    },
  },
  {
    id: 'row12',
    name: {
      value: 'Mexican peso',
    },
    value: {
      value: 'MXN',
    },
  },
  {
    id: 'row13',
    name: {
      value: 'New Taiwan dollar',
    },
    value: {
      value: 'TWD',
    },
  },
  {
    id: 'row14',
    name: {
      value: 'New Zealand dollar',
    },
    value: {
      value: 'NZD',
    },
  },
  {
    id: 'row15',
    name: {
      value: 'Norwegian krone',
    },
    value: {
      value: 'NOK',
    },
  },
  {
    id: 'row16',
    name: {
      value: 'Philippine peso',
    },
    value: {
      value: 'PHP',
    },
  },
  {
    id: 'row17',
    name: {
      value: 'Polish złoty',
    },
    value: {
      value: 'PLN',
    },
  },
  {
    id: 'row18',
    name: {
      value: 'Pound sterling',
    },
    value: {
      value: 'GBP',
    },
  },
  {
    id: 'row19',
    name: {
      value: 'Russian ruble',
    },
    value: {
      value: 'RUB',
    },
  },
  {
    id: 'row20',
    name: {
      value: 'Singapore dollar',
    },
    value: {
      value: 'SGD',
    },
  },
  {
    id: 'row21',
    name: {
      value: 'Swedish krona',
    },
    value: {
      value: 'SEK',
    },
  },
  {
    id: 'row22',
    name: {
      value: 'Swiss franc',
    },
    value: {
      value: 'CHF',
    },
  },
  {
    id: 'row23',
    name: {
      value: 'Thai baht',
    },
    value: {
      value: 'THB',
    },
  },
  {
    id: 'row24',
    name: {
      value: 'United States dollar',
    },
    value: {
      value: 'USD',
    },
  },
]

const columns = {
  name: {
    title: 'Currency',
    width: '50%',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  value: {
    title: 'Code',
    cellAs: CodeCell,
    mobile: {
      placement: 'b3',
    },
  },
}

const options = {
  threshold: 0.4,
  keys: ['name.value', 'value.value'],
}

const fuse = new Fuse(allRows, options)

const CurrencyTable = () => {
  const [rows, setRows] = useState(allRows.slice(0, 5))
  const [isLoading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const showSeeMoreBtn = rows.length < allRows.length
  const [filteredRows, setFilteredRows] = useState([])

  useEffect(() => {
    if (searchInput) {
      setFilteredRows(fuse.search(searchInput).map(({ item }) => item))
    } else {
      setFilteredRows([])
    }
  }, [searchInput])

  const handleTextChange = (e) => {
    setSearchInput(e.target.value)
  }

  const handleSeeMore = () => {
    setSearchInput('')
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }

  return (
    <>
      <TextInputWrapper
        nameValue="basic"
        errorPresent={false}
        errorTextForFpti=""
        name="basic"
        value={searchInput}
        label="Search table"
        labelClassName="test"
        onKeyUp={handleTextChange}
      />
      <DataTable
        description="Basic"
        rows={searchInput ? filteredRows : rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default CurrencyTable
